import React from "react";
import PropTypes from "prop-types";
import { FileText, Gift } from "lucide-react";

import Filter from "../../../../Filter";
import { UIButton } from "../../../../ui";

import "./_EventPayrollToolbar.scss";

const EventPayrollToolbar = ({
  labels,
  search,
  filters,
  genderOptions,
  roleOptions,
  nationalityOptions,
  removedStatusOptions,
  rewardTypeOptions,
  paymentStatusOptions,
  canAdd,
  isGenerateAllDisabled,
  isGiveAllRewardsDisabled,
  isGiveAllRewardsLoading,
  onSearchChange,
  onFilterChange,
  onGenerateAllPayroll,
  onGiveAllRewards,
}) => (
  <Filter
    isCollapsable
    defaultExpanded={false}
    searchInput={{
      placeholder: labels.searchPlaceholder,
      name: "search",
      value: search,
      onChange: onSearchChange,
    }}
    classNames={{
      container: "event-payroll__toolbar",
      base: "event-payroll__toolbar-base",
      search: "event-payroll__search",
    }}
    renderActionBeforeFilterToggle={
      canAdd && (
        <div className="event-payroll__toolbar-actions">
          <UIButton
            type="button"
            variant="primary"
            size="large"
            appearance="outline"
            className="event-payroll__give-all-rewards-btn"
            startIcon={<Gift size={16} strokeWidth={1.5} aria-hidden />}
            onClick={onGiveAllRewards}
            disabled={isGiveAllRewardsDisabled}
            loading={isGiveAllRewardsLoading}
          >
            {labels.giveAllRewards}
          </UIButton>
          <UIButton
            type="button"
            variant="primary"
            size="large"
            appearance="outline"
            className="event-payroll__generate-all-btn"
            startIcon={<FileText size={16} strokeWidth={1.5} aria-hidden />}
            onClick={onGenerateAllPayroll}
            disabled={isGenerateAllDisabled}
          >
            {labels.generateAllPayroll}
          </UIButton>
        </div>
      )
    }
    filters={[
      {
        type: "filter",
        name: "gender",
        placeholder: labels.filters.gender,
        value: filters.gender,
        options: genderOptions,
        onChange: (value) => onFilterChange({ gender: value || null }),
      },
      {
        type: "filter",
        name: "role",
        placeholder: labels.filters.role,
        value: filters.role,
        options: roleOptions,
        onChange: (value) => onFilterChange({ role: value || null }),
      },
      {
        type: "filter",
        name: "nationality",
        placeholder: labels.filters.nationality,
        value: filters.nationality,
        options: nationalityOptions,
        onChange: (value) => onFilterChange({ nationality: value || null }),
      },
      {
        type: "filter",
        name: "removedStatus",
        placeholder: labels.filters.removedStatus,
        value: filters.removedStatus,
        options: removedStatusOptions,
        onChange: (value) => onFilterChange({ removedStatus: value || null }),
      },
      {
        type: "filter",
        name: "rewardType",
        placeholder: labels.filters.rewardType,
        value: filters.rewardType,
        options: rewardTypeOptions,
        onChange: (value) => onFilterChange({ rewardType: value || null }),
      },
      {
        type: "filter",
        name: "paymentStatus",
        placeholder: labels.filters.paymentStatus,
        value: filters.paymentStatus,
        options: paymentStatusOptions,
        onChange: (value) => onFilterChange({ paymentStatus: value || null }),
      },
    ]}
  />
);

EventPayrollToolbar.propTypes = {
  labels: PropTypes.object.isRequired,
  search: PropTypes.string,
  filters: PropTypes.object.isRequired,
  genderOptions: PropTypes.array.isRequired,
  roleOptions: PropTypes.array.isRequired,
  nationalityOptions: PropTypes.array.isRequired,
  removedStatusOptions: PropTypes.array.isRequired,
  rewardTypeOptions: PropTypes.array.isRequired,
  paymentStatusOptions: PropTypes.array.isRequired,
  canAdd: PropTypes.bool,
  isGenerateAllDisabled: PropTypes.bool,
  isGiveAllRewardsDisabled: PropTypes.bool,
  isGiveAllRewardsLoading: PropTypes.bool,
  onSearchChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onGenerateAllPayroll: PropTypes.func.isRequired,
  onGiveAllRewards: PropTypes.func.isRequired,
};

EventPayrollToolbar.defaultProps = {
  search: "",
  canAdd: true,
  isGenerateAllDisabled: false,
  isGiveAllRewardsDisabled: false,
  isGiveAllRewardsLoading: false,
};

export default EventPayrollToolbar;
